import { render, staticRenderFns } from "./_base-body-text.vue?vue&type=template&id=74b1fb48&"
import script from "./_base-body-text.vue?vue&type=script&lang=js&"
export * from "./_base-body-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74b1fb48')) {
      api.createRecord('74b1fb48', component.options)
    } else {
      api.reload('74b1fb48', component.options)
    }
    module.hot.accept("./_base-body-text.vue?vue&type=template&id=74b1fb48&", function () {
      api.rerender('74b1fb48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_base/_base-body-text.vue"
export default component.exports